import React from "react";
import { AlertCircle, Inbox, WifiOff, Clock, Wrench, RefreshCw } from "lucide-react";

// One consistent, honest presenter for loading / empty / error / stale /
// feature_unavailable. Never renders seed or fabricated content.
const PRESET = {
  loading: { icon: Clock, title: "Loading…", detail: "" },
  empty: { icon: Inbox, title: "Nothing here yet", detail: "No records are available for this selection." },
  error: { icon: WifiOff, title: "Couldn't load", detail: "Something went wrong. Check your connection and retry." },
  stale: { icon: Clock, title: "Showing cached data", detail: "Live data is briefly unavailable — this may be out of date." },
  feature_unavailable: { icon: Wrench, title: "Not available yet", detail: "This is being connected to live data. Check back soon." },
};

export function DataState({ state = "loading", title, detail, onRetry, className = "" }) {
  const p = PRESET[state] || PRESET.loading;
  const Icon = p.icon;
  return (
    <div className={`tt-panel rounded-xl p-10 text-center ${className}`} data-testid={`data-state-${state}`}>
      {state === "loading" ? (
        <div className="w-6 h-6 mx-auto mb-3 rounded-full border-2 border-white/20 border-t-[#4ea152] animate-spin" />
      ) : (
        <Icon className="mx-auto mb-3 text-white/30" size={26} />
      )}
      <p className="font-display text-lg text-white">{title || p.title}</p>
      {(detail || p.detail) && <p className="text-white/50 text-sm mt-1 max-w-md mx-auto">{detail || p.detail}</p>}
      {onRetry && state !== "loading" && (
        <button onClick={onRetry} data-testid="data-state-retry" className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#2F7D32] hover:bg-[#276b2a] text-white text-sm transition-colors">
          <RefreshCw size={14} /> Retry
        </button>
      )}
    </div>
  );
}

export function SourceNote({ timestamp, coverage }) {
  if (!timestamp && !coverage) return null;
  let when = "";
  try { if (timestamp) when = new Date(timestamp).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); } catch { /* noop */ }
  return (
    <p className="text-[11px] text-white/35 mt-3" data-testid="source-note">
      {coverage ? `${coverage} · ` : ""}{when ? `Source updated ${when}` : ""}
    </p>
  );
}
